import { Formik } from 'formik';
import { FC } from 'react';
import * as yup from 'yup';
import { FormType, SubheaderInput } from '../../../../../types/FormTypes';
import { ListenToFormikValues } from '../../../../shared/formik/ListenToFormikValues';
import { ToneInputs } from '../formInputs/ToneInputs';
import styles from './SHStyles.module.css';
import formStyles from '../formStyles.module.css';
import { TargetDemographicInputs } from '../formInputs/TargetDemographicInputs';
import { useFormContext } from '../../../../../contexts/FormContext';
import { BrandDescriptionTextarea } from '../formInputs/BrandDescriptionTextarea';
import { GenerateResponseButtons } from '../GenerateResponseButtons';
import { ToggleInput } from '../../../../shared/inputs/ToggleInput';
import { useRouter } from 'next/router';
import { SmallerSimpleBadge } from '../../../../shared/badge/SmallerSimpleBadge';

const SubheaderInputsSchema = yup.object<
  Partial<Record<keyof SubheaderInput, yup.AnySchema>>
>({
  brandDescription: yup
    .string()
    .required('Please describe your brand/product')
    .min(33, 'Description is too vague! Consider adding more details'),
  tone: yup
    .array()
    .of(yup.string())
    .min(1, 'Please select at least 1 tone for your subheader'),
  targetDemographic: yup
    .array()
    .of(yup.string())
    .min(1, 'Please select at least 1 target demographic for your subheader'),
});

export const SubheaderForm: FC = () => {
  const { subheaderInput, setSubheaderInput, loading, submitWebsiteForm } =
    useFormContext();
  const router = useRouter();

  return (
    <Formik
      initialValues={subheaderInput}
      onSubmit={async (values, actions) => {
        await submitWebsiteForm({
          values,
          actions,
          formType: FormType.SUBHEADER,
        });
      }}
      validationSchema={SubheaderInputsSchema}
    >
      {(props) => (
        <>
          <div className={formStyles['form-container']}>
            <ListenToFormikValues
              callBackFunc={(values) => {
                setSubheaderInput(values as SubheaderInput);
              }}
            />
             <div className={styles['toggle']}>
                   <div>
                 <ToggleInput
                 id='manualToggle'
                 disabled={false}
                 isChecked={false}
                 onClick={() => {
                  router.push('/editor/website?formType=persona%20sub%20header')
                 }} 
                 />
                 </div>
              <div className={styles['toggle-name']}>
                <b>Persona Mode</b>
                </div>
                
                </div>
            <div className={styles['create-button2']}>
              <BrandDescriptionTextarea
                formikProps={props}
                disabled={loading}
                placeholder="e.g. We take businesses from zero to one with engaging, relevant, and personalized AI-content that uses machine learning and targeted data."
              />
            </div>
            <div>
              <ToneInputs formikProps={props} disabled={loading} />
            </div>
            <div>
              <TargetDemographicInputs formikProps={props} disabled={loading} />
            </div>
          </div>
          <GenerateResponseButtons onSubmit={() => props.handleSubmit()} />
        </>
      )}
    </Formik>
  );
};
